import style from './style.scss';
import translations from './translations';
import Row from './common/Table/Row';
import Table from './common/Table';
import React, { memo } from 'react';
import Cell from './Cell';
import { T } from 'ramda';
import useTranslate from './hooks/useTranslate';
import { useDynamicReducerSelector } from './state';
import classNames from './common/classNames';

const AwardsTable = (/* No props */) => {

    const prizes = useDynamicReducerSelector(state => state.prizes);
    const t = useTranslate();

    return <Table>
        <div className={style.panelRow}>
            <Cell textClass={classNames(style.panelCellHeaderText, style.prizesHeaderTitle)} additionalClass={style.prizesCell}>
                {t(translations.headerAwardsPrize)}</Cell>
            <Cell textClass={style.panelCellHeaderText}>{t(translations.headerAwardsPrizesAwarded)}</Cell>
            <Cell textClass={classNames(style.panelCellHeaderText, style.prizesRemainHeaderTitle)}
                  additionalClass={style.prizesRemainCell}>{t(translations.headerAwardsPrizesRemaining)}</Cell>
        </div>
        {prizes.map(({ displayName, awarded, remaining, finalPrize }, index) =>
            <Row key={index} className={classNames({ [style.finalPrize]: finalPrize })}
                 classNameOuter={classNames({ [style.finalPrizeOuter]: finalPrize })}>
                <div className={classNames(style.panelContentRow, { [style.correctRowHeight]: finalPrize })}>
                    <Cell textClass={classNames(style.panelCellText, style.panelCellTextFlex)}
                          additionalClass={style.cellStart} isFinalPrize={classNames({ [style.isFinalPrize]: finalPrize })}>
                        <div className={classNames(style.iconClassCell, { [style.finalPrizeImg]: finalPrize })}/>
                        {displayName}</Cell>
                    <Cell textClass={style.panelCellText}
                          isFinalPrize={classNames({ [style.isFinalPrize]: finalPrize })}>{awarded}</Cell>
                    <Cell textClass={classNames(style.panelCellText, style.prizesRemainCellText)}
                          additionalClass={style.prizesRemainCell}
                          isFinalPrize={classNames({ [style.isFinalPrize]: finalPrize })}>{remaining}</Cell>
                </div>
                <div className={classNames(style.horizontalLine, { [style.hide]: finalPrize })} />
            </Row>)}
    </Table>;
};

export default memo(AwardsTable, T);
